import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  deleteIaDiscussion,
  fetchIaDiscussion,
  fetchIaDiscussions,
  newIaDiscussion,
} from "../../REDUX/actions/ia";
import { IaPlusSvg } from "./IaIcons";

/** Historique des discussions de l'utilisateur. */
const IaDiscussionList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { discussions, discussionsLoading, currentDiscussionId } = useSelector(
    (state) => state.iaReducer
  );

  useEffect(() => {
    dispatch(fetchIaDiscussions());
  }, [dispatch]);

  return (
    <div className="iaDiscussionList d-flex flex-column flex-grow-1 overflow-auto customScroll px-3 py-3">
      <button
        type="button"
        className="iaNewDiscussion alignH gap-2 br5 border-0 bg-lightGrey px-3 py-2 mb-3"
        onClick={() => dispatch(newIaDiscussion())}
      >
        <IaPlusSvg />
        <span className="f14 sBold iaBlue">{t("New conversation")}</span>
      </button>

      {discussionsLoading && (
        <span className="f13 normal text-lightBlack">{t("Loading")}...</span>
      )}

      {!discussionsLoading && !discussions.length && (
        <span className="f13 normal text-lightBlack">{t("No conversation yet")}</span>
      )}

      {discussions.map((discussion) => {
        const date = discussion.lastMessageAt || discussion.createdAt;

        return (
          <div
            key={discussion.id}
            className={`iaDiscussionItem alignH justify-content-between br5 px-3 py-2 mb-2 ${
              discussion.id === currentDiscussionId ? "bg-lightBlue" : ""
            }`}
          >
            <button
              type="button"
              className="border-0 bg-transparent text-start flex-grow-1 p-0"
              onClick={() => dispatch(fetchIaDiscussion(discussion.id))}
            >
              <span className="f14 normal text-lightBlack d-block text-truncate">
                {discussion.title || t("Conversation")}
              </span>
              <span className="f11 normal text-lightBlack">
                {date ? moment(date).format("DD/MM/YYYY HH:mm") : ""}
              </span>
            </button>

            <button
              type="button"
              className="iaDiscussionDelete border-0 bg-transparent"
              title={t("Delete")}
              onClick={() => dispatch(deleteIaDiscussion(discussion.id, t))}
            >
              <i className="bi bi-trash text-lightBlack f14" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default IaDiscussionList;
